import PropTypes from "prop-types"

import { SectionTitle } from "areas/product/jewlr/components"
import Image from "components/ui/image"

const magazines = [
  {
    alt: "The Oprah Magazine",
    height: "29px",
    image: require("images/product/info/as_seen_in/The-Oprah-logo.svg"),
    key: "the-oprah-magazine",
    width: "157px",
  },
  {
    alt: "People",
    height: "37px",
    image: require("images/product/info/as_seen_in/People-logo.svg"),
    key: "people",
    width: "92px",
  },
  {
    alt: "Fashion",
    className:
      "h-(--base-height) desktop:h-(--desktop-height) w-(--base-width) desktop:w-(--desktop-width)",
    height: "96px",
    image: require("images/product/info/as_seen_in/fashion-logo.svg"),
    key: "fashion",
    style: {
      "--base-height": "24px",
      "--base-width": "109px",
      "--desktop-height": "29px",
      "--desktop-width": "130px",
    },
    width: "435px",
  },
  {
    alt: "CNN",
    className:
      "h-(--base-height) desktop:h-(--desktop-height) w-(--base-width) desktop:w-(--desktop-width)",
    height: "40px",
    image: require("images/product/info/as_seen_in/CNN-logo.svg"),
    key: "cnn",
    style: {
      "--base-height": "34px",
      "--base-width": "73px",
      "--desktop-height": "40px",
      "--desktop-width": "85px",
    },
    width: "86px",
  },
  {
    alt: "US Weekly",
    className:
      "h-(--base-height) desktop:h-(--desktop-height) w-(--base-width) desktop:w-(--desktop-width)",
    height: "41px",
    image: require("images/product/info/as_seen_in/US-weekly-logo.svg"),
    key: "us-weekly",
    style: {
      "--base-height": "34px",
      "--base-width": "44px",
      "--desktop-height": "40px",
      "--desktop-width": "52px",
    },
    width: "53px",
  },
]

const LandingAsSeenIn = ({ element, lazyload = true }) => (
  <div className="bg-grey-3 py-32" {...element?.style}>
    <div
      className="contained desktop:max-w-1440 tablet:px-0"
      {...element?.container_style}
    >
      <div className="desktop:flex-row desktop:px-32 desktop:gap-60 flex flex-col items-center justify-between gap-24 px-16">
        <SectionTitle>FEATURED IN</SectionTitle>
        <div className="desktop:max-w-4xl desktop:gap-0 desktop:justify-between flex w-full flex-1 flex-wrap items-center justify-center gap-24">
          {magazines.map((magazine) => (
            <Image
              alt={magazine.alt}
              className={magazine.className}
              height={magazine.height}
              key={magazine.key}
              lazyload={lazyload}
              src={magazine.image}
              style={magazine.style}
              width={magazine.width}
            />
          ))}
        </div>
      </div>
    </div>
  </div>
)

LandingAsSeenIn.propTypes = {
  element: PropTypes.object,
  lazyload: PropTypes.bool,
}

export default LandingAsSeenIn
